import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            最近更新
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            实时追踪最新漫画更新动态
          </p>

          <div className="mt-10 max-w-3xl mx-auto">
            <div className="relative">
              <div className="absolute left-[19px] top-2 bottom-2 w-[2px] bg-background-200"></div>

              <div className="space-y-5">
                {updatesData.map((update) => (
                  <div key={update.id} className="relative flex gap-5 pl-[52px]">
                    <div className="absolute left-[12px] top-2 w-[15px] h-[15px] rounded-full border-[3px] border-primary-500 bg-background-50 z-10"></div>
                    <div className="flex-1 bg-background-100 rounded-xl p-4 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-xs text-foreground-400 whitespace-nowrap">
                          {update.date}
                        </span>
                        <span className="px-2 py-0.5 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full whitespace-nowrap">
                          {update.tag}
                        </span>
                      </div>
                      <h3 className="text-base font-heading text-foreground-950">
                        {update.title}
                      </h3>
                      <p className="mt-1 text-sm text-foreground-600">
                        {update.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}